export const ExpandIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="none" {...props}>
    <path
      stroke="#534F63"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.478"
      d="M3.364 9h9.454M3.364 9l1.575-2.5M3.364 9l1.575 2.5M12.82 9l-1.577-2.5M12.818 9l-1.576 2.5m3.94 5v-15M1 16.5v-15"
    />
  </svg>
)
